<script>
  /**
   * @author M.G.
   */
  import {showScheduledMessagesList} from './ScheduledMessagePicker.svelte';
  import DateTimePicker from '../../../Common/DateTimePicker.svelte';
  import {onMount} from 'svelte';
  import {
    appendProperty,
    connectSettings,
    getChannelMessageMaxLength,
    toggleAttachments,
    validateVoiceMessage
  } from './common';
  import {External, M} from '../../../external';
  import {getVoices, getVoicesByLanguage} from './voices';
  import {ignore} from "../../../Common/tools";

  export let popup, contact, message, onChange, showDate = false, enableScheduling = false;

  let datePicker, charCount = 0;
  let language;
  let voices = {};
  let isMessagingEnabled = External.Website.isMessagingEnabled();
	let textarea;

  const PRICE_TIERS = ['Basic', 'Standard', 'Premium'];
  const TIER_LABELS = {
    [PRICE_TIERS[0]]: M.BASIC,
    [PRICE_TIERS[1]]: M.STANDARD,
    [PRICE_TIERS[2]]: M.PREMIUM
  };

  if (!message) {
    message = {
      id: null,
      body: '',
      sendTime: null,
      channel: External.CRM_MESSAGE_CHANNEL.VOICE,
      attachments: null,
      voiceType: null,
    }

    if (showDate) {
      showDatePicker();
    }
  }

  if (!message.body) {
    message.body = '';
  }

  function clearEditor() {
    message.body = '';
    message.sendTime = null;
    message.id = null;
    message.attachments = null;
    //datePicker.value = '';
  }

  async function selectProperty() {
    message.body = await appendProperty(message, textarea); //reassignment triggers the svelte reactivity
  }

  function enableAttachment() {
    message.attachments = toggleAttachments(message);
  }

  function showLinkPicker() {
    External.Website.selectPage({
      modal: true,
      allowEmptyCaption: true,
      allowFunnelStepPicking: false,
      hasNoFollow: false,
      hasOpenIn: false,
      hasCaption: false,
      selected: {
        link: message.attachments?.length && message.attachments[0].url ? message.attachments[0].url : 'https://'
      },
      onSelect: function (result) {
        message.attachments[0].url = result.link;
      }
    });

    for(const tab of ['page', 'store', 'funnels', 'anchor-point', 'popup', 'email', 'phone']) { //hide these tabs
      document.querySelector('.categories-wrapper ul li[data-tab="' + tab + '"]').classList.add('none');
    }
  }

  function sendTest() {
    confirmSend('sendTestMessage', M.SEND_TEST_MESSAGE, M.CONFIRM_SEND_TEST_MESSAGE_DESC, M.TEST_MESSAGE_SENT);
  }

  function sendNow() {
    confirmSend('sendMessage', M.SEND_MESSAGE, M.CONFIRM_SEND_MESSAGE_DESC, M.MESSAGE_SENT);
  }

  function scheduleMessage() {
    if (message.sendTime.getTime() <= new Date().getTime()) {
      sendScheduledNow();
      return;
    }

    let dateFormat = External.WebsiteSettings.getDateFormat();

    let prompt = M.CONFIRM_SCHEDULE_MESSAGE_DESC
      .replace('01/01/1970',
        External.Tools.dateToStr(message.sendTime, dateFormat))
      .replace('00:00',
        External.Tools.timeToString(message.sendTime, dateFormat === 'uk'));

    if (message.id) {                                                                                      //existing scheduled message
      confirmSend('updateScheduledMessage', M.UPDATE_MESSAGE, prompt, M.SCHEDULED_MESSAGE_UPDATED);
    } else {                                                                                               //else create new scheduled message
      confirmSend('scheduleMessage', M.SCHEDULE_MESSAGE, prompt, M.MESSAGE_SUCCESSFULLY_SCHEDULED);
    }
  }

  function sendScheduledNow() {
    confirmSend('sendScheduledMessage', M.SEND_MESSAGE, M.CONFIRM_SEND_MESSAGE_DESC, M.MESSAGE_SENT);
  }

  function confirmSend(requestAction, promptHeading, promptDesc, successMsg) {
    try {
      validateVoiceMessage(message);
    } catch (e) {
      External.Tools.showError(e);
      return;
    }

    if(contact) {
      message.contactId = contact.id;
    }

    External.Tools.prompt(promptHeading, promptDesc, () => {
      External.Tools.makeWebsiteRequest({
        action: requestAction,
        method: 'post',
        data: {
          message: JSON.stringify(message),
          channel: message.channel
        },
        onOk: () => {
          External.Tools.showAutohideMessage(5, successMsg);
          if (onChange) {
            onChange();
          }
          if (popup) {
            popup.close();
          }
        }
      });
    });
  }

  function cancel() {
    if (message.body && !message.id) {
      External.Tools.prompt(M.DISCARD_MESSAGE, M.DISCARD_MESSAGE_DESC, () => {
        popup.close();
      });
      return;
    }
    popup.close();
  }

  function showDatePicker() {
    if (!message.sendTime) {
      let date = new Date();
      date.setDate(date.getDate() + 1);
      message.sendTime = date;
      External.$('#datePicker').click();
    }
  }

  function hideDatePicker() {
    message.sendTime = null;
  }

  function dateChanged(value) {
    message.sendTime = new Date(value);
  }

  async function showScheduledMessages() {
    await showScheduledMessagesList(contact, External.CRM_MESSAGE_CHANNEL.VOICE, setEditorData, clearEditor, () => {
      External.Tools.prompt(M.SCHEDULED_MESSAGES, M.NO_MESSAGES_SCHEDULED, () => {
        showDatePicker();
      });
    });
  }

  export async function setEditorData(msg) {
    if (msg) {
      message = msg;
    }
    return true;
  }

  function selectLanguage(resetVoiceType) {
    let langMap = getVoicesByLanguage(language);

    for(const tierIndex in PRICE_TIERS) {
      let tierVoices = langMap[PRICE_TIERS[tierIndex]];
      let tier = PRICE_TIERS[tierIndex];
      voices[tier] = [];
      if(tierVoices?.length) {
        for(const voiceIndex in tierVoices) {
          let voiceData = tierVoices[voiceIndex].split(',');  //eg F,Google.ar-XA-Standard-A'
          voices[tier].push({
            gender: voiceData[0],
            name: voiceData[1]
          });
        }
      }
    }

    if(resetVoiceType) {
      message.voiceType = '0';
    }
  }

  function findLocaleLanguageCode() {
    if(window.locale !== 'en') {
      let voiceMap = getVoices();
      for (const key in voiceMap) {
        if (key.startsWith(window.locale)) {
          return key;
        }
      }
    }
    return 'en-GB';
  }

  function showHelp() {
    const url = External.Website.onboarding['booking'] || ''; //TODO

    if (url === ''){
      console.log("showHelp empty url");
      return;
    }

    const embedUrl = External.CPanel.getEmbedVideo(url);

    if (embedUrl !== '') {
      const title = M.HEY + ' ' + External.userName.split(' ')[0];
      const	text = M.CHECK_VIDEO;

      External.Tools.showWindow({
        isModal: false,
        withDarkBackground: true,
        title: '',
        noNav: true,
        noTitle: true,
        markup: External.WebPlatform.format(External.Templates.get('introPopup'), 'titleclz', '', 'textclz', '',
          'title', title, 'text', text, 'video', embedUrl, 'clz', 'none'),
        icon: External.Popup.ICON_ADD,
        width: 850
      });
    }
  }

  function settingsConnected() {
    isMessagingEnabled = true;
  }

  $: {
    charCount = message.body.length;

    if(message.sendTime?.formattedTime && datePicker) {  //the datePicker is displayed if the message sendTime or id is set, but when setting the msg setEditorData function, the reaction does not happen until the function returns which causes an undefined error, so do it here
      datePicker.value = message.sendTime.formattedTime;
    }

    if (onChange) {
      onChange(message);
    }
  }

  onMount(() => {
    if(message.voiceType) {
      language = message.voiceType.split(":")[0]; //eg en-GB:Polly.Amy
      selectLanguage(false);
    } else {
      language = findLocaleLanguageCode();
      selectLanguage(true);
    }
  });

</script>

<style>
  select optgroup {
    font-style: normal;
    font-weight: normal;
    /*font-size: 13px;*/
  }

  select {
    text-indent: 10px;
  }

  option {
    text-indent: 10px;
    padding: 0px
  }

</style>

<div class='col20 f-left small-rules flex-1 flex-col justify-center' style='overflow-y: auto;'> <!--padding to accommodate the absolute positioning on the help btn-->

  {#if !isMessagingEnabled}
    <div class='col20 f-right mb-20'>
      <div on:click={() => connectSettings(settingsConnected)} class="limit-warning-line flex align-center col20 cursor-pointer">
        <span class="material-icons flex-none">error</span>
        <div class="flex-1"><h4 class="col20 f-left"><u>{M.PLEASE_CONNECT_TWILIO}</u></h4>
        </div>
      </div>
    </div>
  {/if}

  <div class='col20 f-left'>
    <div class='info'>
      <div class='f-left col8'>
        <h5>{M.VOICE}</h5>
        <span class='light-gray-text'>{M.SELECT_LANGUAGE_LOCALE_DESC}</span>
          <select class='page-select' bind:value={language} on:change={selectLanguage}>
            <option value='0' disabled>{M.PLEASE_SELECT}</option>
            <option value='en-GB'>English (UK)</option>
            <option value='en-US'>English (US)</option>
            <option value='en-AU'>English (AUS)</option>
            <option value='en-IE'>English (IRE)</option>
            <option value='en-ZA'>English (ZA)</option>
            <!--((platformId === 5947 || platformId === 9597 || window.inTestEnvironment) ? '<option value='de_LU'>Deutsch (Sie)</option><option value='de_CH'>Deutsch (Schweiz)</option>' : '') +--> <!--not supported-->
            <option value='fr-FR'>Français</option>
            <option value='it-IT'>Italiano</option>
            <option value='es-ES'>Español</option>
            <option value='es-MX'>Español (Mexicano)</option>
            <option value='el-GR'>Ελληνικά</option>
            <option value='pt-BR'>Português (BR)</option>
            <option value='pt-PT'>Português (PT)</option>
            <option value='de-DE'>Deutsch</option>
            <option value='nl-NL'>Nederlandse</option>
            <option value='da-DK'>Dansk</option>
            <option value='nb-NO'>Norsk</option>
            <option value='fi-FI'>Suomi</option>
            <option value='sv-SE'>Svenska</option>
            <option value='is-IS'>Íslenska</option>
            <option value='pl-PL'>Polski</option>
            <option value='ro-RO'>Română</option>
            <option value='hu-HU'>Magyar</option>
            <option value='bg-BG'>Български</option>
            <option value='ru-RU'>Русский</option>
            <option value='uk-UA'>Українська</option>
            <!--<option value='ka'>ქართული</option>-->
            <option value='lt-LT'>Lietuvis (LT)</option>
            <option value='lv-LV'>Latvietis (LV)</option>
            <!--<option value='sl'>Slovenščina</option>-->
            <option value='sk-SK'>Slovák</option>
            <option value='cs-CZ'>čeština</option>
            <option value='sr-RS'>Српски</option>
            <option value='tr-TR'>Türkçe</option>
            <option value='cy-GB'>Cymraeg</option>
            <option value='ar-XA'>عربى</option>
            <option value='ar-AE'>العربية</option>
            <!--<option value='hr'>Hrvatski</option>-->
            <!--<option value='et'>Eesti keel</option>-->
            <option value='cmn-CN'>普通话</option>
            <option value='yue-CN'>粤语</option>
            <option value='yue-HK'>香港粤语</option>
            <option value='cmn-TW'>台湾普通话</option>
            <option value='he-IL'>עִברִית</option>
            <option value='ja-JP'>日本人</option>
            <option value='id-ID'>Bahasa Indonesia</option>
            <option value='ms-MY'>Bahasa Melayu</option>
            <option value='fil-PH'>Filipino</option>
            <option value='ko-KR'>한국어</option>
            <option value='th-TH'>ไทย</option>
            <option value='vi-VN'>Tiếng Việt</option>
            <option value='hi-IN'>हिंदी</option>
            <option value='bn-IN'>বাংলা</option>
            <option value='mr-IN'>मराठी</option>
            <option value='ta-IN'>தமிழ்</option>
          </select>
      </div>

      <div class='f-right col11' style='position: relative'>
        <div class="f-left">
          <h5 style="visibility: hidden">{M.SPEECH_ENGINE}</h5>
          <span class='light-gray-text'>{M.SELECT_VOICE_DESC}</span>
        </div>

        <select class='page-select' bind:value={message.voiceType}>
          <option value='0' disabled>{M.PLEASE_SELECT}</option>
            {#key voices}
              {#each Object.entries(voices) as [tier, tierVoices]}
                {#if tierVoices?.length}
                  <optgroup label='&#128193;&nbsp;&nbsp;{TIER_LABELS[tier]}'>
                    {#each tierVoices as voice}
                      <option value='{language}:{voice.name}'>{voice.name} - {voice.gender === 'M' ? M.MALE : M.FEMALE}</option>
                    {/each}
                  </optgroup>
                {/if}
              {/each}
            {/key}
        </select>
      </div>
    </div>
  </div>

  {#key isMessagingEnabled}
    <div class='single-message-textarea f-left col20 rich-text-area' style='padding-bottom: 0px'>
     <textarea bind:this={textarea} bind:value={message.body} maxlength='{getChannelMessageMaxLength(External.CRM_MESSAGE_CHANNEL.VOICE)}'  style='line-height: 23px; height: 100%; min-height: 152px; max-width: 560px; border-radius: 3px; margin-top: 9px; margin-bottom: 14px' placeholder={M.TYPE_YOUR_MESSAGE}></textarea> <!--14px bottom margin is as per the email editor styling-->
    </div>
  {/key}

  <div class='col20 f-left'>
    <a on:click={selectProperty} class='f-left rounded-effect inline-block single-email-schedule-button'>
      <span class='flex align-center'>
        <svg viewBox='0 0 24 24' height='24' width='24' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='SVGRepo_bgCarrier' stroke-width='0'></g><g id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'></g><g id='SVGRepo_iconCarrier'> <path d='M8.00005 9C8.55233 9 9.00005 8.55228 9.00005 8C9.00005 7.44772 8.55233 7 8.00005 7C7.44776 7 7.00005 7.44772 7.00005 8C7.00005 8.55228 7.44776 9 8.00005 9Z' fill='#0F1729'></path> <path fill-rule='evenodd' clip-rule='evenodd' d='M12.1635 2.05864C11.6504 1.962 11.1228 2.00288 10.4302 2.05655L7.49854 2.2821C6.80865 2.33516 6.23449 2.37931 5.76481 2.4522C5.27385 2.52839 4.82331 2.64559 4.39819 2.88284C3.76237 3.23769 3.23773 3.76232 2.88289 4.39814C2.64563 4.82326 2.52844 5.2738 2.45225 5.76476C2.37936 6.23444 2.3352 6.8086 2.28214 7.49849L2.05659 10.4301C2.00292 11.1228 1.96204 11.6504 2.05869 12.1635C2.14036 12.597 2.2945 13.0137 2.51464 13.396C2.77515 13.8484 3.14954 14.2224 3.64107 14.7134L8.65467 19.7269C9.16802 20.2403 9.59268 20.665 9.96589 20.9856C10.3535 21.3187 10.7457 21.5938 11.2112 21.7632C12.0788 22.0789 13.0298 22.0789 13.8974 21.7632C14.3629 21.5938 14.7551 21.3187 15.1427 20.9856C15.5159 20.665 15.9406 20.2403 16.4539 19.7269L19.727 16.4539C20.2403 15.9405 20.665 15.5158 20.9857 15.1426C21.3187 14.755 21.5938 14.3628 21.7632 13.8973C22.079 13.0298 22.079 12.0787 21.7632 11.2112C21.5938 10.7457 21.3187 10.3535 20.9857 9.96584C20.665 9.59262 20.2403 9.16794 19.7269 8.65458L14.7134 3.64103C14.2225 3.1495 13.8485 2.7751 13.396 2.51459C13.0137 2.29445 12.597 2.14031 12.1635 2.05864ZM10.4701 4.05943C11.327 3.99351 11.5732 3.98263 11.7933 4.02408C12.006 4.06415 12.2105 4.13978 12.3981 4.2478C12.5921 4.35952 12.772 4.52802 13.3797 5.13578L18.2859 10.042C18.8329 10.589 19.2033 10.9603 19.4687 11.2692C19.7274 11.5702 19.8313 11.751 19.8838 11.8952C20.0388 12.3209 20.0388 12.7876 19.8838 13.2133C19.8313 13.3575 19.7274 13.5382 19.4687 13.8393C19.2033 14.1482 18.8329 14.5195 18.2859 15.0665L15.0666 18.2859C14.5196 18.8328 14.1482 19.2032 13.8393 19.4687C13.5383 19.7273 13.3575 19.8313 13.2133 19.8838C12.7876 20.0387 12.321 20.0387 11.8953 19.8838C11.751 19.8313 11.5703 19.7273 11.2693 19.4687C10.9603 19.2032 10.589 18.8328 10.042 18.2859L5.13583 13.3797C4.52807 12.7719 4.35957 12.592 4.24785 12.398C4.13983 12.2104 4.0642 12.006 4.02412 11.7932C3.98268 11.5732 3.99356 11.327 4.05948 10.47L4.27333 7.68986C4.33007 6.95232 4.36897 6.45566 4.42859 6.07147C4.48624 5.69996 4.55341 5.50883 4.62932 5.37281C4.80344 5.06082 5.06087 4.80339 5.37286 4.62928C5.50888 4.55336 5.7 4.4862 6.07151 4.42854C6.45571 4.36892 6.95237 4.33002 7.6899 4.27329L10.4701 4.05943Z' fill='#0F1729'></path> </g></svg>
        {M.ADD_TAG}
      </span>
    </a>

    <a on:click={enableAttachment} class:blue={!!message.attachments} class='f-left ml-5 rounded-effect inline-block single-email-schedule-button'>
      <span class='flex align-center'>
        <svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 -960 960 960' width='24'>
          <path d='M120-200q-33 0-56.5-23.5T40-280v-400q0-33 23.5-56.5T120-760h400q33 0 56.5 23.5T600-680v400q0 33-23.5 56.5T520-200H120Zm600-320q-17 0-28.5-11.5T680-560v-160q0-17 11.5-28.5T720-760h160q17 0 28.5 11.5T920-720v160q0 17-11.5 28.5T880-520H720Zm40-80h80v-80h-80v80ZM120-280h400v-400H120v400Zm40-80h320L375-500l-75 100-55-73-85 113Zm560 160q-17 0-28.5-11.5T680-240v-160q0-17 11.5-28.5T720-440h160q17 0 28.5 11.5T920-400v160q0 17-11.5 28.5T880-200H720Zm40-80h80v-80h-80v80Zm-640 0v-400 400Zm640-320v-80 80Zm0 320v-80 80Z'></path>
        </svg>
        {M.ATTACH}
      </span>
    </a>

    <a on:click={sendTest} class='f-left ml-5 rounded-effect inline-block single-email-schedule-button'>
      <span class='flex align-center'>
        <svg viewBox='0 0 16 16' height='24' width='24' xmlns='http://www.w3.org/2000/svg' fill='#000000'><g id='SVGRepo_bgCarrier' stroke-width='0'></g><g id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'></g><g id='SVGRepo_iconCarrier'> <rect width='16' height='16' id='icon-bound' fill='none'></rect> <path d='M2,9.014L3.414,7.6L6.004,10.189L12.593,3.6L14.007,5.014L6.003,13.017L2,9.014Z'></path> </g></svg>
        {M.SEND_TEST_MESSAGE}
      </span>
    </a>

    {#if enableScheduling}
      {#if !message.id}
        <a on:click={() => {message.sendTime ? hideDatePicker() : showDatePicker()}} class:blue={!!message.sendTime}
           class='f-left ml-5 rounded-effect inline-block single-email-schedule-button'>
            <span class='flex align-center'>
              <svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 -960 960 960' width='24'><path
                d='M200-640h560v-80H200v80Zm0 0v-80 80Zm0 560q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v227q-19-9-39-15t-41-9v-43H200v400h252q7 22 16.5 42T491-80H200Zm520 40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Zm67-105 28-28-75-75v-112h-40v128l87 87Z'/></svg>
              {M.SCHEDULE_EMAIL_BTN}
            </span>
        </a>
      {/if}

      <a class='schedule-history-btn f-left ml-5 rounded-effect button-tooltip' on:click={showScheduledMessages}
         data-tooltip='view_scheduled_messages'>
        <svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 -960 960 960' width='24'>
          <path
            d='m787-145 28-28-75-75v-112h-40v128l87 87Zm-587 25q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z'/>
        </svg>
      </a>
    {/if}

    <span class='f-right contact-message-char-counter'>
      <span class='flex align-center'>
        {charCount}
      </span>
    </span>
  </div>

  {#key message.attachments}
    {#if message.attachments?.length}
      <div class='col20 f-left mt-15'>
        <div class='info'>
          <h5>{M.ATTACH_AUDIO}</h5>
          <span class='light-gray-text'>
          {M.ATTACH_AUDIO_DESC}
        </span>
        </div>
        <div style='margin-left: 3px'>
          {#each message.attachments as attachment, i}
            <input class='path-select col20' type='text' style='background: white' bind:value={attachment.url} on:click={isMessagingEnabled ? showLinkPicker : ignore} />
          {/each}
        </div>
      </div>
    {/if}
  {/key}

  {#if message.sendTime || message.id}
    <div class='col20 f-left mt-15'>
      <div class='info'>
        <h5>{M.SEND_DATE}</h5>
        <span class='light-gray-text'>
          {M.SELECT_MESSAGE_SEND_DATE_DESC}
        </span>
      </div>
      <DateTimePicker bind:instance={datePicker} bind:value={message.sendTime} onChange='{dateChanged}' readonly={true}/>
    </div>
  {/if}

</div>

<slot name='footerButtons' {message} {isMessagingEnabled} {scheduleMessage} {sendNow} {sendScheduledNow} {cancel} />
